const translations = {
    en: {
        restaurants: {
            menu: {
                title: "In Hotel we serve..."
            }
        }
    },
    de: {
        restaurants: {
            menu: {
                title: "Im Hotel servieren wir..."
            }
        }
    },
    es: {
        restaurants: {
            menu: {
                title: "En el hotel ofrecemos..."
            }
        }
    },
    fr: {
        restaurants: {
            menu: {
                title: "Dans l'hotel nous servons..."
            }
        }
    },
    it: {
        restaurants: {
            menu: {
                title: "In Hotel serviamo..."
            }
        }
    }
};

export default translations;



// WEBPACK FOOTER //
// ./translations/restaurants/Menu.js